export default [
    {
        name: 'cadastro-convenio-odontologico',
        path: 'convenio-odontologico',
        redirect: 'convenio-odontologico/index',
        component: () => import(/* webpackChunkName: 'cadastro-convenio-odontologico' */ '@/views/cadastro/convenio-odontologico/Index'),
        children: [
            {
                meta: { title: 'Lista de convênios odontológicos' },
                name: 'cadastro-convenio-odontologico-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-convenio-odontologico' */ '@/views/cadastro/convenio-odontologico/List.vue'),
            },
            {
                meta: { title: 'Cadastro de convênio odontológico' },
                name: 'cadastro-convenio-odontologico-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-convenio-odontologico' */ '@/views/cadastro/convenio-odontologico/Form.vue'),
            },
            {
                meta: { title: 'Edição de convênio odontológico' },
                name: 'cadastro-convenio-odontologico-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-convenio-odontologico' */ '@/views/cadastro/convenio-odontologico/Form.vue'),
            },
        ],
    },
]